import { render, staticRenderFns } from "./ListTeachPc.vue?vue&type=template&id=906f88be&scoped=true"
import script from "./ListTeachPc.vue?vue&type=script&lang=js"
export * from "./ListTeachPc.vue?vue&type=script&lang=js"
import style0 from "./ListTeachPc.vue?vue&type=style&index=0&id=906f88be&prod&lang=less&scoped=true"
import style1 from "./ListTeachPc.vue?vue&type=style&index=1&id=906f88be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906f88be",
  null
  
)

export default component.exports